export type MpsDocument = {
  documentId: string;
  idempotencyId: string;
  type: string;
  status: string;
};

export type MpsDocumentsDossier = {
  documents: MpsDocument[];
};

export type PayoutStatus = 'sent_to_bank' | 'in_progress' | 'kyc_failed' | 'not_applicable';

export type VenuePayout = {
  id: string;
  payoutNumber: number | null;
  country: Country;
  currency: Currency;
  doNotPay: boolean;
  endDate: string;
  interval: 'hexa_monthly' | 'semi_monthly' | 'weekly' | 'monthly' | 'custom';
  intervalNumber: number;
  numberOfPurchases: number;
  payoutAmount: number;
  startDate: string;
  toAccount: string;
  transferStatus: PayoutStatus;
  venue: string;
  year: number;
  invoiceDossierExists: boolean;
  csvReportExists: boolean;
  isMpsPayout: boolean;
  endToEndId: number;
};

export enum MerchantPayoutStatus {
  SUCCESS = 'SUCCESS',
  RUNNING = 'RUNNING',
  FAILED = 'FAILED',
  NO_VENUES = 'NO_VENUES',
}

export enum PayoutIntervalType {
  HEXA_MONTHLY = 'HEXA_MONTHLY',
  SEMI_MONTHLY = 'SEMI_MONTHLY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  CUSTOM = 'CUSTOM',
}

type PayoutInterval = {
  type: PayoutIntervalType;
  number: number;
  year: number;
  startDate: string;
  endDate: string;
};

export type MerchantPayout = {
  id: string;
  merchantId: string;
  country: Country;
  venueIds: string[];
  venuePayoutIds: string[];
  status: MerchantPayoutStatus;
  interval: PayoutInterval;
  successfulVenuePayoutIds: string[];
  failedVenuePayoutIds: string[];
  payoutAmount: number;
  archived: boolean;
};

export type AllMerchantPayouts = {
  isOptedInMerchantLevelArchiving: boolean;
  merchantBankAccount: string;
  currency: Currency;
  payouts: MerchantPayout[];
};

export type BrandPayout = {
  id: string;
  brandId: string;
  venueIds: string[];
  interval: PayoutInterval;
  payoutAmount: number;
  archived: boolean;
};

export type AllBrandPayouts = {
  currency: Currency;
  payouts: BrandPayout[];
};
